/**
 * @module CustomersMenu
 */

import Component from '../base/Component';
import './styles.css';

/**
 * Меню Клиентам
 */
export default class CustomersMenu extends Component {
    static className = 'сustomers-menu';
}

$(document).on('click', '.customers-menu__toggle-btn', toggleCustomersMenu);

function toggleCustomersMenu(e) {
    const { currentTarget } = e;
    const $target = $(currentTarget);
    const $menuBody = $target.closest('.customers-menu').find('.customers-menu__body');

    if ($target.hasClass('is-active')) {
        $target.removeClass('is-active');
        $menuBody.slideUp();
    } else {
        $target.addClass('is-active');
        $menuBody.slideDown();
    }
}
